import React, { useState, useContext, useRef } from "react";
import { AppContext } from "../../App";
import "./Bill.scss";
import { URL } from "../../constants/url";
import formatNumberWithCommas from "../format/formatNumberWithCommas";
import RemoveDayOfWeek from "../format/RemoveDayOfWeek";
import ConfirmDialog from "../confirmdialog/ConfirmDialog";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ReactToPrint from "react-to-print";
import { ComponentToPrint } from "../BillPaper.jsx/BillPaper";
import ViewBillDetails from "../viewbill/ViewBillDetail";
import { Select } from "antd";

const Bill = () => {
  const { billData, setBillData } = useContext(AppContext);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const currentYear = new Date().getFullYear();
  const years = [currentYear - 2, currentYear - 1, currentYear];
  const componentRef = useRef();

  const handleItemClick = (index) => {
    setSelectedItemIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const deleteItem = () => {
    if (itemToDelete !== null) {
      const id = itemToDelete;
      const apiUrl = `${URL}/api/bills/${id}`;

      fetch(apiUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            const updatedBillData = [...billData];
            const index = updatedBillData.findIndex((item) => item._id === id);

            if (index !== -1) {
              updatedBillData.splice(index, 1);
              setBillData(updatedBillData);
            } else {
              console.error("Item not found in the product data.");
            }

            setSelectedItemIndex(null);
            setShowConfirm(false);
            setItemToDelete(null);
          } else {
            console.error("Error deleting item:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting item:", error);
        });
    }
  };

  const filteredBillData = billData.filter((item) => {
    const normalizedString = `${item.idRoom}-${RemoveDayOfWeek(
      item.Date
    )}-${formatNumberWithCommas(item.TotalPayment)}#${item.Debt}`
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    const normalizedSearchQuery = searchQuery
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

    let [, date] = item.Date.includes("-")
      ? item.Date.split("-")
      : item.Date.split("/");
    const [, month, year] = date.split("/");

    return (
      normalizedString.includes(normalizedSearchQuery) &&
      (selectedMonth === "" || month === selectedMonth) &&
      (selectedYear === "" || year === selectedYear)
    );
  });

  const handleCancel = () => {
    setShowConfirm(false);
    setItemToDelete(null);
  };

  const totalPaymentSum = filteredBillData.reduce(
    (accumulator, currentValue) => {
      return parseInt(accumulator) + parseInt(currentValue.TotalPayment);
    },
    0
  );

  const seletedItembyId = billData.find(
    (item) => item._id === selectedItemIndex
  );

  const seletedItemDelete = billData.find((item) => item._id === itemToDelete);

  // console.log(seletedItemDelete.TotalPayment)

  const { Option } = Select;
  return (
    <div className="main-frame-tab-bill">
      <div className="list-bill">
        <div className="main-frame-filter">
          <div className="filters">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Select
              value={selectedMonth}
              onChange={(value) => setSelectedMonth(value)}
              placeholder="All Months"
              className="select-antdesign"
            >
              <Option value="">All Months</Option>
              {[...Array(12)].map((_, i) => (
                <Option key={i} value={String(i + 1).padStart(2, "0")}>
                  T{i + 1}
                </Option>
              ))}
            </Select>

            <Select
              value={selectedYear}
              onChange={(value) => setSelectedYear(value)}
              placeholder="All Years"
              className="select-antdesign"
            >
              <Option value="">All Years</Option>
              {years.map((year) => (
                <Option key={year} value={String(year)}>
                  {year}
                </Option>
              ))}
            </Select>
          </div>

          <div className="frame-total-bill">
            <h3>Total Bills: {filteredBillData.length}</h3>
            <h3>Revenue: {formatNumberWithCommas(totalPaymentSum)}</h3>
          </div>
        </div>

        <div>
          {filteredBillData.map((item, index) => (
            <div key={index} className="frame-nameOfBill-delete">
              <div
                className="NameOfBill"
                onClick={() => handleItemClick(item._id)}
              >
                <p>
                  {item.idRoom}-{RemoveDayOfWeek(item.Date)}-
                  {formatNumberWithCommas(item.TotalPayment)}#{item.Debt}
                </p>
              </div>

              {selectedItemIndex === item._id ? (
                <VisibilityOffIcon
                  onClick={() => handleItemClick(item._id)}
                  className="visibility"
                />
              ) : (
                <VisibilityIcon
                  onClick={() => handleItemClick(item._id)}
                  className="visibility"
                />
              )}
              <button
                onClick={() => {
                  setShowConfirm(true);
                  setItemToDelete(item._id);
                }}
              >
                Remove
              </button>
            </div>
          ))}
          {filteredBillData.length === 0 && <p>No items found.</p>}
        </div>
      </div>
      <>
        <div className="frame-bill-button-print">
          <div className="frame-view-bill">
            <div>
              {seletedItembyId !== undefined && (
                <ViewBillDetails billItem={seletedItembyId} />
              )}
            </div>
          </div>

          <div>
            <ReactToPrint
              trigger={() => (
                <button
                  className="button-app-payment"
                  disabled={seletedItembyId === undefined}
                >
                  Export Bill
                </button>
              )}
              content={() => componentRef.current}
            />
            {seletedItembyId !== undefined && (
              <div style={{ display: "none" }}>
                <ComponentToPrint
                  ref={componentRef}
                  billData={seletedItembyId}
                />
              </div>
            )}
          </div>
        </div>

        {showConfirm && (
          <ConfirmDialog
            message={`Are you sure you want to delete bill ${formatNumberWithCommas(seletedItemDelete.TotalPayment)}?`}
            onConfirm={deleteItem}
            onCancel={handleCancel}
          />
        )}
      </>
    </div>
  );
};

export default Bill;
